<template>
  <div class="patronage">
    <h1>Patronage for {{ headerName }}</h1>

    <b-table :data="tableData">
      <b-table-column field="description"
                      v-slot="props">
        {{ props.row.description }}
      </b-table-column>
      <!-- TODO: note that this column header is empty via "simple" method -->
      <b-table-column field="value"
                      label=" "
                      numeric
                      v-slot="props">
        {{ props.row.value }}
      </b-table-column>
    </b-table>

    <br />

    <p class="block">
      * Patronage total since 9/26/05 
    </p>

    <div v-if="patronage.fiscal_year">
      <br />

      <p v-if="patronage.fiscal_year >= 2024" class="block has-text-weight-bold">
        Patronage Refund/Loyalty Points will be available on {{ patronage.refund_issued }}
      </p>

      <h2>Fiscal {{ patronage.fiscal_year }}</h2>

      <p class="block">
        Thank you for shopping your Co-op! Your investment in the
        Co-op helps us to continue to provide high-quality healthy
        food to our community and support local growers and
        producers. One of the primary benefits of being a co-op member
        is to share in the profits of the co-op. Our co-op had a
        profitable year in {{ patronage.fiscal_year }} and our Board
        of Directors voted to distribute {{ patronage.fiscal_year_refund_total }}
        back to the members. Below is the information specific to your
        member account and your patronage refund.
      </p>

      <p class="block">
        Total amount spent at the Co-op in Fiscal {{ patronage.fiscal_year }}:&nbsp;
        <span class="has-text-weight-bold">
          {{ patronage.fiscal_year_patronage_amount || "n/a" }}
        </span>
      </p>

      <p class="block">
        Total Patronage Refund:&nbsp;
        <span class="has-text-weight-bold">
          {{ patronage.fiscal_year_refund_amount || "n/a" }}
        </span>
      </p>

      <p class="block">
        <span class="has-text-weight-bold">Fiscal {{ patronage.fiscal_year }} – </span>
        {{ patronage.fiscal_year_start_date }}
        –
        {{ patronage.fiscal_year_end_date }}
      </p>

      <p class="block">
        <span class="has-text-weight-bold">How is my Refund Calculated?</span><br />
        What you spent at the Co-op in {{ patronage.fiscal_year }}
        divided by total sales to members.<br />  Sales to Members in
        fiscal {{ patronage.fiscal_year }} = {{ patronage.fiscal_year_patronage_total }}
        <br /> This number is then multiplied by the distributable
        surplus ({{ patronage.fiscal_year_refund_total }}) to
        calculate each member’s individual share.
      </p>

      <p class="block">
        <span class="has-text-weight-bold">How can I redeem my Patronage Refund?</span><br />
        Patronage Refunds will be loaded onto individual member
        accounts as a store credit/loyalty points to be used at the
        register. You can apply your entire refund to a single shop or
        use it in any increments you like.
      </p>

      <p class="block">
        <span class="has-text-weight-bold">Can I get a check instead of having to use Loyalty Points?</span><br />
        Possibly. We will only issue a check if the patronage refund
        is greater than $5 and the check will only be made payable to
        the member of record. The member will need to contact Angela
        Borowski, and these checks may take 6-8 weeks to
        process. Store credits/loyalty points are available
        immediately.
      </p>

      <p class="block">
        <span class="has-text-weight-bold">Will the Loyalty Points expire?</span><br />

        <span v-if="patronage.fiscal_year >= 2024">
          Yes. Loyalty Points from Patronage Refunds expire 3 years from issue date
          which will be {{ patronage.refund_expires }}. Expired loyalty points will
          then be donated to the coop's Farmers Resilience Fund.
        </span>

        <span v-else>
          Yes. Loyalty Points from Patronage Refunds that are not used
          by the end of fiscal {{ patronage.next_fiscal_year }}
          ({{ patronage.next_fiscal_year_end_date }}) will be donated
          to the Co-op’s Farmers Resilience Fund.
        </span>

      </p>

      <p class="block">
        <span class="has-text-weight-bold">Have more questions about your refund?</span><br />
        Click the feedback option in the right-hand corner and choose
        'Finance' in the drop-down menu.
      </p>

    </div>
  </div>
</template>

<script>
export default {
    name: 'Patronage',
    data() {
        return {
            inited: false,
            patronage: {},
            tableData: [],
        }
    },
    computed: {
        headerName: function() {
            if (! this.$store.state.user.uuid) {
                return ""
            }
            let name = this.$store.state.user.display_name
            if (this.patronage.customer_number) {
                return name + " #" + this.patronage.customer_number
            }
            return name
        },
    },
    created: function() {
        this.init()
    },
    watch: {
        '$store.state.session_established': 'init',
    },
    methods: {

        init() {
            // only need to init once
            if (this.inited) {
                return
            }

            // cannot init until session is established
            if (!this.$store.state.session_established) {
                return
            }

            // is someone logged in?
            if (this.$store.state.user.uuid) {
                // go ahead and fetch data if it's a member
                if (this.$store.state.user.member) {
                    this.fetchData()
                } else { // send non-members back to "home" page
                    this.$router.push('/')
                }
            } else { // send logged-out users to "login" instead
                this.$router.push('/login')
            }

            // we did it!
            this.inited = true
        },

        fetchData() {
            this.$http.get('/api/my/patronage').then(response => {
                if (response.data.error) {
                    // TODO: should be smarter than just knee-jerk redirect?
                    this.$router.push('/benefits')
                } else {
                    this.patronage = response.data
                    this.tableData = [
                        {description: "Month to Date Patronage", value: this.patronage.patronage_month},
                        {description: "Year to Date Patronage", value: this.patronage.patronage_year},
                        {description: "Patronage Total *", value: this.patronage.patronage_total},
                    ]
                }
            }, response => {
                // TODO: should be smarter than just knee-jerk redirect?
                this.$router.push('/benefits')
            })
        },
    },
}
</script>
